/**
 * Authors: mariushirjanu
 * Created: 22/04/2021
 */
import { Injectable } from '@angular/core';

import { HttpDataService } from '../../http/http-data.service';

export const CHARGETYPE_GLOBAL:string = 'GLOBAL';
export const CHARGETYPE_LOCAL:string = 'LOCAL';

export interface IChargebackMargin {
  chargebackMarginType:string;
  chargebackMargin:string;
}

@Injectable()
export class MarginsDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /***/
  }

  public getChargebackMargin(marginId:number):Promise<IChargebackMargin> {
    return this.httpDataService.doGET(
      `rest/margins/${marginId}/chargebackmargin`,
      {},
      undefined,
      'Error loading margin'
    );
  }
}